import { Trans } from '@lingui/react'

import { OFFER_TYPE_MIRAKL } from 'shared/consts/marketplace'
import {
  OTC_MODES,
  PRESCRIPTION_TYPE_NO_PRESCRIPTION,
  PRESCRIPTION_TYPE_PRIVAT,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import { getListPriceSuperScript } from 'views/utils/productUtils'

export const baseClasses = 'a-h5 u-no-margin u-padding--left'

export const createSecondaryPrice = ({ title, superScripts, pharmaObl }) => {
  const supNumber = getListPriceSuperScript({
    superScripts,
    pharmaObl,
  })

  return {
    title,
    superScripts: supNumber && <sup>{supNumber}</sup>,
  }
}

export const getYourPriceContent = ({
  price,
  listPriceTitle,
  secondaryPrice = null,
}) => (
  <>
    <span className="u-hidden@pre-medium-small-tiny">
      {price.title}
      {price.superScripts}
    </span>
    {secondaryPrice && (
      <span
        className={`u-hidden@pre-medium ${
          secondaryPrice.title === listPriceTitle ? 'u-color--grey' : ''
        }`}
      >
        {secondaryPrice.title}
        {secondaryPrice.title === listPriceTitle
          ? secondaryPrice.superScripts
          : null}
      </span>
    )}
  </>
)

export const pickProductProps = ({
  id,
  upid,
  name,
  category,
  unitQuantityString,
  unit,
  unitPricing,
  canonicalURL,
  followUpProductCode,
  ICD10,
  discount,
  stockStatus,
  prices,
  offerId,
  odsPartners,
  pharmaObl,
  descriptionShort,
  thumbnailURL,
  brandName,
  numberOfRatings,
  rating,
  manufacturer,
  displayCode,
  flags,
  lifestyleProduct,
  subtitle,
}) => ({
  id,
  upid,
  name,
  category,
  unitQuantityString,
  unit,
  unitPricing,
  canonicalURL,
  followUpProductCode,
  ICD10,
  discount,
  stockStatus,
  prices,
  offerId,
  odsPartners,
  pharmaObl,
  descriptionShort,
  thumbnailURL,
  brandName,
  numberOfRatings,
  rating,
  manufacturer,
  displayCode,
  flags,
  lifestyleProduct,
  subtitle,
})

export const getListPriceColumn = ({ superScripts, pharmaObl }) => {
  const supNumber = getListPriceSuperScript({
    superScripts,
    pharmaObl,
  })

  return (
    <span>
      <Trans id="general.label.listPrice" />
      {supNumber && <sup>{supNumber}</sup>}
    </span>
  )
}

export const getMiraklListPriceColumn = ({ superScripts, pharmaObl }) => {
  const supNumber = getListPriceSuperScript({
    superScripts,
    pharmaObl,
  })
  return (
    <span>
      <Trans id="general.label.miraklListPrice" />
      {supNumber && <sup>{supNumber}</sup>}
    </span>
  )
}

export const getYourPriceColumn = ({
  useOTCMode,
  prescriptionType,
  superScripts,
  pharmaObl,
  offerType,
  i18n,
}) => {
  const title =
    useOTCMode || prescriptionType === PRESCRIPTION_TYPE_PRIVAT
      ? i18n._('general.label.yourPrice')
      : i18n._('general.label.additionalCharge')
  const priceSuperScripts = superScripts.price && (
    <sup>{superScripts.price}</sup>
  )
  const listPriceTitle =
    offerType === OFFER_TYPE_MIRAKL
      ? i18n._('general.label.miraklListPrice')
      : i18n._('general.label.listPrice')

  return getYourPriceContent({
    price: {
      title,
      superScripts: priceSuperScripts,
    },
    secondaryPrice: (() => {
      if (prescriptionType === PRESCRIPTION_TYPE_NO_PRESCRIPTION) {
        return createSecondaryPrice({
          title: listPriceTitle,
          superScripts,
          pharmaObl,
        })
      }

      return createSecondaryPrice({ title, superScripts, pharmaObl })
    })(),
    listPriceTitle,
  })
}

export const shouldUseOTCMode = ({ productTemplate, prescriptionType }) =>
  productTemplate === PRODUCT_TEMPLATES.OTC ||
  OTC_MODES.includes(prescriptionType)
